import { APP_INITIALIZER, inject, Injectable, Injector, NgModule } from '@angular/core';
import {
  provideTransloco,
  TranslocoLoader,
  TranslocoModule,
  Translation,
  TranslocoService
} from '@jsverse/transloco';
import { validLocales, userLocale, setUserLocale } from './models/locale.model';
import { HttpClient } from '@angular/common/http';
import { catchError, Observable } from 'rxjs';

// Local loader
@Injectable({ providedIn: 'root' })
export class LocalHttpLoader implements TranslocoLoader {
  private http = inject(HttpClient);

  getTranslation(lang: string): Observable<Translation> {
    return this.http.get<Translation>(`/assets/i18n/${lang}.json`).pipe(
      catchError(() => {
        const fallback = 'en-WW'
        console.warn(`Missing lang "${lang}", loading fallback "${fallback}"`);
        setUserLocale(fallback);
        return this.http.get<Translation>(`/assets/i18n/${fallback}.json`);
      })
    );
  }

}

export function initializeTransloco(service: TranslocoService) {
  return () => {
    const lang = userLocale || service.getActiveLang() || 'en-WW';
    service.setActiveLang(lang);
    return service.load(lang);
  };
}

@NgModule({
  exports: [TranslocoModule],
  providers: [
    provideTransloco({
      config: {
        availableLangs: validLocales,
        defaultLang: 'en-WW',
        fallbackLang: 'en-WW',
        reRenderOnLangChange: true
      },
      loader: LocalHttpLoader
    }),
    {
      provide: APP_INITIALIZER,
      multi: true,
      useFactory: initializeTransloco,
      deps: [TranslocoService]
    }
  ]
})
export class TranslocoRootModule { }